// src/components/Header.js
import React from 'react';
import { Navbar, Nav, Container, Button, Badge, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
    const { user, logout } = useAuth();
    const { t } = useTranslation();

    const handleLogout = () => {
        logout();
    };

    return (
        <header style={{ position: 'relative', zIndex: 1000 }}>
            <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect className="web3-navbar">
                <Container>
                    <LinkContainer to="/">
                        <Navbar.Brand>
                            <div className="brand-logo">
                                <div className="brand-icon">
                                    <span className="brand-letter">H</span>
                                </div>
                                <span className="logo-text">HashControl</span>
                            </div>
                        </Navbar.Brand>
                    </LinkContainer>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            {user && (
                                <>
                                    <LinkContainer to="/dashboard">
                                        <Nav.Link>{t('common.dashboard')}</Nav.Link>
                                    </LinkContainer>

                                    {/* Пункт меню для селлеров */}
                                    {user.isSeller && (
                                        <NavDropdown title={t('referral.program')} id="seller-dropdown">
                                            <LinkContainer to="/referrals/links">
                                                <NavDropdown.Item>{t('referral.myLinks')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to="/referrals/users">
                                                <NavDropdown.Item>{t('referral.myReferrals')}</NavDropdown.Item>
                                            </LinkContainer>
                                        </NavDropdown>
                                    )}

                                    {/* Админ-меню */}
                                    {user.isAdmin && (
                                        <NavDropdown title={t('admin.panel')} id="admin-dropdown">
                                            <LinkContainer to="/admin">
                                                <NavDropdown.Item>{t('admin.dashboard')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <NavDropdown.Divider />
                                            <LinkContainer to="/admin/users">
                                                <NavDropdown.Item>{t('admin.users')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to="/admin/flight-sheets">
                                                <NavDropdown.Item>{t('dashboard.flightSheets')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to="/admin/stats">
                                                <NavDropdown.Item>{t('admin.stats')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <NavDropdown.Divider />
                                            <LinkContainer to="/admin/sellers">
                                                <NavDropdown.Item>{t('admin.sellers')}</NavDropdown.Item>
                                            </LinkContainer>
                                            <LinkContainer to="/admin/referral-links">
                                                <NavDropdown.Item>{t('admin.referralLinks')}</NavDropdown.Item>
                                            </LinkContainer>
                                        </NavDropdown>
                                    )}
                                </>
                            )}
                        </Nav>

                        <Nav className="ms-auto" style={{ alignItems: 'center' }}>
                            {/* Переключатель языка */}
                            <div className="me-3" style={{ zIndex: 1050 }}>
                                <LanguageSwitcher />
                            </div>

                            {user ? (
                                <>
                                    <Nav.Item className="d-flex align-items-center me-3">
                                        <span className="text-light">
                                            <span className="text-secondary me-2">{t('common.user')}:</span>
                                            <span className="gradient-text">{user.username}</span>
                                            {user.isAdmin && (
                                                <Badge bg="warning" className="ms-2" pill>{t('common.admin')}</Badge>
                                            )}
                                            {user.isSeller && (
                                                <Badge bg="info" className="ms-2" pill>{t('seller.seller')}</Badge>
                                            )}
                                        </span>
                                    </Nav.Item>
                                    <Button
                                        variant="outline-light"
                                        onClick={handleLogout}
                                        className="btn-highlight"
                                    >
                                        {t('common.logout')}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <LinkContainer to="/login">
                                        <Nav.Link className="me-2">
                                            <Button variant="outline-primary" size="sm">
                                                {t('common.login')}
                                            </Button>
                                        </Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to="/register">
                                        <Nav.Link>
                                            <Button variant="primary" size="sm">
                                                {t('common.register')}
                                            </Button>
                                        </Nav.Link>
                                    </LinkContainer>
                                </>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default Header;